import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import { advancedColors } from '../theme'

type Props = {
  label: string
  value: React.ReactNode
  caption?: string
}

const StatTile = ({ label, value, caption }: Props) => (
  <Paper sx={{ px: 2.5, py: 2 }}>
    <Typography variant="overline">{label}</Typography>
    <Box
      sx={{
        mt: 0.75,
        fontSize: '1.25rem',
        lineHeight: 1.1,
        fontWeight: 600,
        color: advancedColors.deep,
        fontVariantNumeric: 'tabular-nums',
      }}
    >
      {value}
    </Box>
    {caption && (
      <Typography variant="subtitle2" sx={{ mt: 0.5, color: advancedColors.inkMuted }}>
        {caption}
      </Typography>
    )}
  </Paper>
)

export default StatTile
